import request from '@/utils/request'
import { downloadBlob } from '@/utils/download'

/**
 * 财务管理 - 折扣修改审核（折扣申请列表）
 * 接口: POST /cust/customer/changProfitRatioList
 */
const apiPath = '/finance/discountModificationAudit'
const listApiPath = '/cust/customer/changProfitRatioList'

const discountModificationAuditApi = {
  /**
   * 分页查询【折扣申请】列表
   * @param {Object} query - 查询参数
   * @param {number} query.pageNo - 页码
   * @param {number} query.pageSize - 每页条数
   * @param {string} query.nameOrPho - 提交人姓名电话
   * @param {string} query.customerNameOrPho - 用户姓名电话
   * @param {string} query.customerLevel - 用户级别
   * @param {string} query.cityName - 城市公司
   * @param {string} query.position - 提交人职位
   * @param {string} query.startCreatedTime - 提交开始时间
   * @param {string} query.endCreatedTime - 提交结束时间
   * @param {string} query.startAuditTime - 审核开始时间
   * @param {string} query.endAuditTime - 审核结束时间
   */
  fetchList(query) {
    return request.post(listApiPath, query)
  },

  /**
   * 检查客户是否有待审核的折扣申请
   * @param {number} customerId - 客户ID
   */
  checkPendingByCustomer(customerId) {
    return request.post(listApiPath, {
      pageNo: 1,
      pageSize: 1,
      customerId,
      auditStatus: '0'
    })
  },

  /**
   * 审核申请（form data 格式）
   * @param {Object} params - { id: 申请ID, state: 审核状态 0待审核 1已审核 2驳回, reason?: 驳回原因 }
   */
  audit(params) {
    const data = {
      id: params.id,
      state: params.state
    }
    if (params.reason != null && params.reason !== '') {
      data.statereason = params.reason
    }
    return request.post('/cust/customer/auditChangProfitRatio', data, {
      isFormData: 1
    })
  },

  /**
   * 同意申请
   * @param {Object} data - { id: 申请ID }
   */
  approve(data) {
    return this.audit({ id: data.id, state: 1 })
  },

  /**
   * 驳回申请
   * @param {Object} data - { id: 申请ID, reason: 驳回原因 }
   */
  reject(data) {
    return this.audit({ id: data.id, state: 2, reason: data.reason })
  },

  /**
   * 创建导出任务（异步导出，跳转导出页面使用）
   * 后端需创建任务，任务 code 为 DiscountModificationAuditExport，用于 sysTask 查询
   */
  createExportTask(data) {
    return request.post(apiPath + '/createExportTask', data)
  },

  /**
   * 导出折扣申请（直接下载）
   * @param {Object} data - downloadChangProfitRatioQO
   * @param {string} data.cityName - 城市公司
   * @param {number} data.customerLevel - 用户级别
   * @param {string} data.customerNameOrPho - 用户姓名电话
   * @param {string} data.nameOrPho - 提交人姓名电话
   * @param {string} data.position - 提交人职位
   * @param {string} data.startAuditTime - 审核开始时间
   * @param {string} data.endAuditTime - 审核结束时间
   * @param {string} data.startCreatedTime - 提交开始时间
   * @param {string} data.endCreatedTime - 提交结束时间
   * @param {number} data.pageNo - 页码
   * @param {number} data.pageSize - 每页条数
   */
  downloadChangProfitRatio(data) {
    return request
      .post('/cust/customer/downloadChangProfitRatio', data || {}, { responseType: 'blob' })
      .then(res => downloadBlob(res, '折扣修改审核列表.xlsx'))
  }
}

export default discountModificationAuditApi
